import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-observations',
  template: `
    <div>
      <legend class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" *ngIf="props.label">{{ props.label }}</legend>
      <p *ngIf="props.description">{{ props.description }}</p>
      <div *ngFor="let field of field.fieldGroup; let i = index" class="mb-2">
        <div class="flex flex-wrap">
          <formly-field
            class="w-full sm:w-12/12"
            [field]="field">
          </formly-field>
        </div>
      </div>
    </div>
  `,
})
export class RepeatObservationsComponent extends FieldArrayType {
  constructor() {
    super();
  }
}
